import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-modal-item-view',
  templateUrl: './modal-item-view.component.html',
  styleUrls: ['./modal-item-view.component.scss'],
})
export class ModalItemViewComponent {
  @Input() title: string | undefined;
  @Input() description: string | undefined;
  @Input() imagesource: string | undefined;
  @Input() arrowIcon?: boolean | undefined = true;

  constructor() {}
}
